export function isRightDrawerOutlet(outletName: string): boolean {
	return outletName.startsWith('[right-drawer]');
}
